import { render, staticRenderFns } from "./error-404.vue?vue&type=template&id=c71387b4&scoped=true&"
import script from "./error-404.vue?vue&type=script&lang=js&"
export * from "./error-404.vue?vue&type=script&lang=js&"
import style0 from "./error-404.vue?vue&type=style&index=0&id=c71387b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71387b4",
  null
  
)

export default component.exports